const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseKey);

export const supabaseRequest = async (path, options = {}) => {
  if (!hasSupabaseConfig) {
    throw new Error('Supabase is not configured');
  }

  const { profile, headers, ...fetchOptions } = options;
  return fetch(`${supabaseUrl}/rest/v1/${path}`, {
    ...fetchOptions,
    headers: {
      apikey: supabaseKey,
      Authorization: `Bearer ${supabaseKey}`,
      'Content-Type': 'application/json',
      ...(profile ? { 'Accept-Profile': profile, 'Content-Profile': profile } : {}),
      ...(headers || {}),
    },
  });
};
